module.exports = __webpack_public_path__ + "static/media/giftsSent_750_1000.21f7e6bc.png";